import { empty } from '@codeArt/utils/common';
import _ from 'lodash';

const TestStatus = {
    ing: 1, //检测中
    idle: 2 //闲置中
}

export { TestStatus };